import React, { useEffect, useState } from 'react';
import { Table, Button, Badge, Modal } from 'react-bootstrap';
import { Select } from "antd";
import Pagination from "react-js-pagination";
import { getComplianceList, rejectSignature, getEmployeeList } from "../../../config/services/employeeServices";
import { Toastify } from "../../helper/Constant";
import ResponseFilter from "../../../ResponseFilter";

import ViewUploadedPdf from "../PrivacyModal/ViewUploadedPdf";

const { Option } = Select;

const PolicyCompliance = () => {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [actionLoading, setActionLoading] = useState(false);
    const [resMsg, setResMsg] = useState(false);
    const [resFailMsg, setResFailMsg] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");
    const [employeeList, setEmployeeList] = useState([]);
    const [employeeId, setEmployeeId] = useState("");
    const [pageNo, setPageNo] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [count] = useState(10);

    // Modal State
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectId, setRejectId] = useState(null);

    // View Modal State
    const [showViewModal, setShowViewModal] = useState(false);
    const [viewDocUrl, setViewDocUrl] = useState("");

    useEffect(() => {
        getEmployeeList("count=10000&status=1&pageNo=0").then(res => {
            const { status, resData } = ResponseFilter(res);
            if (status) {
                // Deduplicate using a Map
                const uniqueEmployees = Array.from(new Map(resData.employeesList.map(emp => [emp.employeeId || emp._id, emp])).values());
                setEmployeeList(uniqueEmployees);
            }
        });
    }, []);

    useEffect(() => {
        fetchCompliance();
    }, [pageNo, employeeId]);

    const fetchCompliance = () => {
        setLoading(true);
        let params = `pageNo=${pageNo}&count=${count}`;
        if (employeeId) {
            params += `&userId=${employeeId}`;
        }
        getComplianceList(params)
            .then(res => {
                if (res.data.statusCode === 1) {
                    setList(res.data.responseData.list);
                    setTotalCount(res.data.responseData.totalCount);
                }
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    };

    const handleEmployeeChange = (value) => {
        setEmployeeId(value);
        setPageNo(1);
    };

    const handlePageChange = (page) => {
        setPageNo(page);
    };

    const handleRejectClick = (id) => {
        setRejectId(id);
        setShowRejectModal(true);
    };

    const confirmReject = () => {
        if (!rejectId) return;

        setShowRejectModal(false);
        setActionLoading(rejectId);

        rejectSignature({ acknowledgementId: rejectId })
            .then(res => {
                setResMsg(true);
                setResponseMessage("Signature rejected successfully.");
                setActionLoading(false);
                setRejectId(null);
                fetchCompliance();
                setTimeout(() => setResMsg(false), 3000);
            })
            .catch(err => {
                setResFailMsg(true);
                setResponseMessage("Failed to reject signature.");
                setActionLoading(false);
                setRejectId(null);
                setTimeout(() => setResFailMsg(false), 3000);
            });
    };

    const handleViewClick = (url) => {
        setViewDocUrl(url);
        setShowViewModal(true);
    };

    const getStatusBadge = (status) => {
        if (status === 1) return <Badge variant="success">Signed</Badge>;
        if (status === 2) return <Badge variant="danger">Rejected</Badge>;
        return <Badge variant="secondary">Unknown</Badge>;
    };

    const handleSort = (field) => {
        // Placeholder for sort, implementation can be added if needed
    };

    return (
        <div className="mt-4">
            <Toastify
                resMsg={resMsg}
                resMsgFail={resFailMsg}
                text={responseMessage}
                responseMessage={responseMessage}
            />
            {loading ? (
                <div className="text-center p-5">Loading compliance data...</div>
            ) : (
                <>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className="mb-0 text-uppercase" style={{ fontWeight: 'bold' }}>Compliance Status</h3>
                        <div style={{ width: 250 }}>
                            <Select
                                showSearch
                                name="employeeId"
                                placeholder="Select Name"
                                value={employeeId || undefined}
                                onChange={handleEmployeeChange}
                                optionFilterProp="key"
                                className="w-100"
                                filterOption={(input, option) =>
                                    option.key.toLowerCase().includes(input.toLowerCase())
                                }
                                allowClear
                                size="large"
                            >
                                {employeeList.map((emp) => (
                                    <Option
                                        key={`${emp.firstName} ${emp.lastName}`}
                                        value={emp.employeeId || emp._id}
                                    >
                                        <span>
                                            {emp.firstName} {emp.lastName} ({emp.empId})
                                        </span>
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="white bg_blue">
                                <tr>
                                    <th scope="col">Employee ID</th>
                                    <th scope="col">Employee</th>
                                    <th scope="col">Policy</th>
                                    <th scope="col">Version</th>
                                    <th scope="col">Signed Date</th>
                                    <th scope="col">Status</th>
                                    <th scope="col" className="table-width text-right">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {list && list.length > 0 ? list.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.user.empId}</td>
                                        <td>
                                            <div className="font-weight-bold">{item.user.firstName} {item.user.lastName}</div>
                                            <small className="text-muted">{item.user.email}</small>
                                        </td>
                                        <td>{item.policy.title}</td>
                                        <td>v{item.policyVersion}</td>
                                        <td>{new Date(item.signedAt).toLocaleDateString()} {new Date(item.signedAt).toLocaleTimeString()}</td>
                                        <td>{getStatusBadge(item.status)}</td>
                                        <td className="text-right table-width">
                                            <div className="d-flex justify-content-end align-items-center">
                                                {item.signedPdfUrl && (
                                                    <>
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            className="mr-2"
                                                            title="View Document"
                                                            onClick={() => handleViewClick(item.signedPdfUrl)}
                                                        >
                                                            <i className="fa fa-eye"></i>
                                                        </Button>
                                                        <a
                                                            href={item.signedPdfUrl}
                                                            download
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-sm btn-outline-dark mr-2"
                                                            title="Download PDF"
                                                        >
                                                            <i className="fa fa-cloud-download"></i>
                                                        </a>
                                                    </>
                                                )}
                                                {item.status === 1 && (
                                                    <Button
                                                        variant="outline-danger"
                                                        size="sm"
                                                        title="Reject Signature"
                                                        onClick={() => handleRejectClick(item._id)}
                                                        disabled={!!actionLoading}
                                                    >
                                                        {actionLoading === item._id ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-times"></i>}
                                                    </Button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="7" className="text-center py-4">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {totalCount > count && (
                            <div className="d-flex justify-content-end mt-3">
                                <Pagination
                                    activePage={pageNo}
                                    itemsCountPerPage={count}
                                    totalItemsCount={totalCount}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                />
                            </div>
                        )}
                    </div>
                </>
            )}

            {/* Reject Confirmation Modal */}
            <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Rejection</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to reject this signature? The user will have to sign again.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowRejectModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={confirmReject}>
                        Reject
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* View Document Modal */}
            <ViewUploadedPdf
                show={showViewModal}
                doc={viewDocUrl}
                closeModal={() => setShowViewModal(false)}
            />
        </div>
    );
};

export default PolicyCompliance;
